if (!customElements.get('preorder-status')) {
  customElements.define(
    'preorder-status',
    class PreorderStatus extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.dataset.ready = 'true';
        this.productInfo = this.closest('product-info');
        this.propertyInput = this.querySelector('[data-preorder-property]');
        this.mediaBadges = this.productInfo?.querySelectorAll('[data-preorder-media-badge]') || [];
        this.variantInput = this.closest('form[data-type="add-to-cart-form"]')?.querySelector('[name="id"]');

        try {
          this.variants = JSON.parse(this.querySelector('[data-preorder-variants]')?.textContent || '[]');
        } catch (error) {
          this.variants = [];
          console.error('Unable to read pre-order variant inventory:', error);
        }

        this.update(Number(this.dataset.selectedVariantId));
        this.variantInput?.addEventListener('change', this.handleVariantInputChange);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== String(this.dataset.sectionId)) return;
          this.update(Number(data.variant?.id));
        });
      }

      disconnectedCallback() {
        this.variantInput?.removeEventListener('change', this.handleVariantInputChange);
        this.unsubscribe?.();
      }

      handleVariantInputChange = (event) => {
        this.update(Number(event.target.value));
      };

      update(variantId) {
        const isPreorder = this.variants.find((variant) => Number(variant.id) === variantId)?.preorder === true;
        this.classList.toggle('hidden', !isPreorder);
        this.propertyInput?.toggleAttribute('disabled', !isPreorder);
        this.mediaBadges.forEach((badge) => badge.classList.toggle('hidden', !isPreorder));
      }
    }
  );
}
